export class BillRatesDto {
  public companyID: string;
  public jobClass: string;
  public otRate: number;
  public pdRate: number;
  public ptRate: number;
  public stRate: number;
  public template: string;
}
